import React from "react";
import { BarChart } from "@mui/x-charts";

const SuperAdminRevenueGraph = ({ selectedDuration }) => {
  const getData = () => {
    switch (selectedDuration) {
      case "currentweek":
        return [
          { category: "Mon", value: 100 },
          { category: "Tue", value: 200 },
          { category: "Wed", value: 150 },
          { category: "Thu", value: 180 },
          { category: "Fri", value: 220 },
          { category: "Sat", value: 90 },
          { category: "Sun", value: 120 },
        ];
      case "last12months":
        return [
          { category: "Jan", value: 1200 },
          { category: "Feb", value: 1500 },
          { category: "Mar", value: 1400 },
          { category: "Apr", value: 1700 },
          { category: "May", value: 1600 },
          { category: "Jun", value: 1800 },
          { category: "Jul", value: 2000 },
          { category: "Aug", value: 2100 },
          { category: "Sep", value: 1900 },
          { category: "Oct", value: 2200 },
          { category: "Nov", value: 2300 },
          { category: "Dec", value: 2500 },
        ];
      case "all":
      default:
        return [
          { category: "2024", value: 1000 },
          { category: "2023", value: 2000 },
          { category: "2022", value: 1500 },
          { category: "2021", value: 1700 },
          { category: "2020", value: 1000 },
          { category: "2019", value: 2000 },
          { category: "2018", value: 1500 },
          { category: "2017", value: 1700 },
          { category: "2016", value: 1700 },
          { category: "2015", value: 1000 },
          { category: "2014", value: 2000 },
          { category: "2013", value: 1500 },
          { category: "2012", value: 1700 },
        ];
    }
  };

  const data = getData();

  return (
    <div className="w-full">
      <BarChart
        dataset={data}
        xAxis={[{ scaleType: "band", dataKey: "category" }]}
        yAxis={[{ scaleType: "linear" }]}
        series={[
          {
            dataKey: "value",
            valueFormatter: (value) => value!=null&&!isNaN(value)?`$${value.toFixed(2)}`:"$0.00",
            color: "#0037FF",
          },
        ]}
        margin={{ right: 30, left: 60 }}
        height={350}
      />
    </div>
  );
};

export default SuperAdminRevenueGraph;
